export default function Input({ type, id, place, register, error }) {
  return <div>
    <input className={input} type={type} id={id} placeholder={place} {...register} />
  </div> 
}
const input = 'rounded border border-gray-700 w-full p-1 mb-10 outline-none text-sm'
